const footerLinks = {
  navigation: [
    { label: '焦点爆料', href: '#carousel' },
    { label: '热门黑料', href: '#cards' },
    { label: '吃瓜热度榜', href: '#ranking' },
    { label: '热门话题', href: '#topics' },
    { label: '视频吃瓜', href: '#media' },
    { label: '实时快讯', href: '#updates' },
  ],
  features: [
    { label: '投稿爆料', href: '#contact' },
    { label: '关于我们', href: '#about' },
    { label: '专题合集', href: '#index' },
    { label: '平台特色', href: '#features' },
    { label: '常见问题', href: '#faq' },
    { label: 'APP下载', href: '#app' },
  ],
};

export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-foreground-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <span className="text-xl font-heading font-bold text-white">51每日大赛</span>
            <p className="text-sm text-foreground-300 mt-3 leading-relaxed">
              国内领先的吃瓜爆料内容聚集平台，每日更新最热吃瓜事件，提供官网最新地址、app下载及在线观看入口。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#app" className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-accent-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-white"></i>
              </a>
              <a href="#app" className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-accent-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-white"></i>
              </a>
              <a href="#contact" className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-accent-500 transition-colors cursor-pointer">
                <i className="ri-mail-line text-white"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold text-white mb-4">内容导航</h3>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                    className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer no-underline"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold text-white mb-4">更多功能</h3>
            <ul className="space-y-2.5">
              {footerLinks.features.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                    className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer no-underline"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-bold text-white mb-4">合作伙伴</h3>
            <p className="text-sm text-foreground-400 leading-relaxed">
              合作伙伴信息持续更新中，欢迎优质平台洽谈合作。
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2023-2026 51每日大赛 版权所有 | 吃瓜黑料爆料聚集地
          </p>
          <p className="text-xs text-foreground-500">
            每日大赛吃瓜黑料 · 实时吃瓜入口 · 爆料聚集地
          </p>
        </div>
      </div>
    </footer>
  );
}